import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetListOfPopUpPages(payload) {
    if (payload) {
      let qs = createQueryString(payload);
      return Api().get(`/api/pop-up-pages/get-popup-pages${qs}`);
    } else {
      return Api().get(`/api/pop-up-pages/get-popup-pages`);
    }
  },
  MultipleImages(payload) {
    return Api().post("/multiple-upload", payload);
  },
  AddListOfPages(payload) {
    return Api().post("/api/admin/list-of-pages", payload);
  },
  UpdatePopupPageStatus(payload) {
    return Api().post(
      `/api/pop-up-pages/popup-pages-status/${payload.pp_id}`,
      payload
    );
  },
  AddPopup(payload) {
    return Api().post("/api/pop-up-pages/popup-pages", payload);
  },
  getSinglePopup(payload) {
    return Api().get(`/api/pop-up-pages/get-popup-pages?pp_id=${payload}`);
  },
  GetListOfPages(payload) {
    if (payload) {
      return Api().get(`/api/admin/list-of-pages${payload ? payload : ""}`);
    } else {
      return Api().get(`/api/admin/list-of-pages`);
    }
  },
  //Fnb Dynamic Pricin
  GetAllActiveFnbItems(payload) {
    return Api().post("/api/admin/getallactivefnbitems", payload);
  },
  GetFnbTaxPrice(payload) {
    return Api().post("/api/admin/getfnbaddtionalprice/", payload);
  },
  GetAllFnbDynamicPricing(payload) {
    if (
      payload &&
      payload.hasOwnProperty("searchValue") &&
      payload.hasOwnProperty("columnName")
    ) {
      return Api().post(
        `/api/admin/allfnbdynamicpricing?limit=${payload.limit}&currentPage=${payload.currentPage}&searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
        payload
      );
    } else {
      return Api().post(
        `/api/admin/allfnbdynamicpricing?limit=${payload.limit}&currentPage=${payload.currentPage}`,
        payload
      );
    }
  },
  AddDynamicPricing(payload) {
    return Api().post("/api/admin/fnbdynamicpricing", payload);
  },
  EditDynamicPricing(payload) {
    return Api().put("/api/admin/fnbdynamicpricing", payload);
  },
  GetSingleFnbDynamicPricing(payload) {
    return Api().get(`/api/admin/fnbdynamicpricing/${payload.fdp_common_id}`);
  },
  //Payment Options
  AddBookingPaymentOptions(payload) {
    return Api().post(`/api/admin/bookingsourcepaymentmapping`, payload);
  },
  ReserveSeat(payload) {
    return Api().post(`/api/admin/reserveSeat`, payload);
  },
  GetReservationIds(payload) {
    return Api().post(`/api/admin/get-reserve-ids`, payload);
  },
  GetSystemLogs(payload) {
    return Api().get(
      `/system-logs?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}`
    );
  },
  GetSwapTransactions(payload) {
    let qs = createQueryString(payload);
    return Api_2().get(`/api/admin/swaptransactions${qs}`);
  },
  GetSwapRefundExcel(payload) {
    return Api_2().post(`/api/admin/swapRefundExcel`, payload);
  },
  GetUnpaidBookingTransactions(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/unpaidBookings${qs}`);
  },
  CancelUnpaidBooking(payload) {
    return Api().put(`/api/admin/unpaidBookings/${payload.reservation_id}`);
  },
  SendMailUnpaidBooking(payload) {
    return Api().get(
      `/api/pos/get-ticket-details/${payload.reservation_id}/${payload.customer_id}/11111111111111`
    );
  },
  GetReservationsBySearch(payload) {
    return Api().post(`/api/pos/search-reserve-ids`, payload);
  },
  GetScheduleDetails(payload) {
    return Api().get(`/api/admin/schedule_details/${payload.ss_id}`);
  },
  GetAvailableScreenList(payload) {
    return Api().get(`/api/admin/available_screen_list/${payload.ss_id}`);
  },
  GetAvailableScheduleList(payload) {
    return Api().get(`/api/admin/available_schedule_list/${payload.ss_id}`);
  },
  GetSwapScreenLayout(payload) {
    return Api().get(`/api/admin/getSwapScreenLayout/${payload.screen_id}`);
  },
  GetMovieScreenLayout(payload) {
    return Api().post(`/api/admin/getMovieSeatLayout`, payload);
  },
  SwapAuditorium(payload) {
    return Api().post(
      `/api/admin/swapAuditorium/${payload.ss_id}/${payload.md_id}/${payload.screen_id}/${payload.type}`,
      payload
    );
  },
  AddTerritory(payload) {
    return Api().post("/api/territory/add-territory", payload);
  },
  GetTerritoryData(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/territory/territory${qs}`);
  },
  AddStockReason(payload) {
    return Api().post("/api/stockReason/edit-stock-take-reasons", payload);
  },
  GetStockReasonData(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/stockReason/stock-take-reasons${qs}`);
  },
  GetBookedTransactions(payload) {
    return Api().post(`/api/reports/getTransactionsForShowRefund`, payload);
  },
  MakeBulkRefundTransactions(payload) {
    return Api().post(`/api/admin/bulkRefundTransactions`, payload);
  },

  FetchAllowedIps(payload) {
    return Api().get(
      `/api/admin/allowed-ips/get-allowed-ips/${payload.cinema_id}`
    );
  },
  AddAllowedIps(payload) {
    return Api().post(`/api/admin/allowed-ips/add-allowed-ips`, payload);
  },
  UpdateAllowedIps(payload) {
    return Api().post(`/api/admin/allowed-ips/update-allowed-ips`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ExhibitorService.js